import { render, staticRenderFns } from "./billCatalog.vue?vue&type=template&id=0544fbd9&"
import script from "./billCatalog.vue?vue&type=script&lang=js&"
export * from "./billCatalog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports